export const personalPlanWeekChildResult = {
  Model: {
    class: 'plan',
    properties: {
      tenantId: '3',
      responseType: 'GroupByResource',
      viewOptions: {
        'grouped-by': 'group-by-resource',
        'reporting-types': 'utilization',
        'period-types': 'week',
        'unit-types': 'hours',
        'period-starts-at': '2025-03-27',
        'period-ends-at': '2025-04-26',
      },
      periods: [
        {
          startsAt: '2025-03-24T00:00:00',
          endsAt: '2025-03-30T00:00:00',
          type: 'Week',
          identifier: '2025W13',
        },
        {
          startsAt: '2025-03-31T00:00:00',
          endsAt: '2025-04-06T00:00:00',
          type: 'Week',
          identifier: '2025W14',
        },
        {
          startsAt: '2025-04-07T00:00:00',
          endsAt: '2025-04-13T00:00:00',
          type: 'Week',
          identifier: '2025W15',
        },
        {
          startsAt: '2025-04-14T00:00:00',
          endsAt: '2025-04-20T00:00:00',
          type: 'Week',
          identifier: '2025W16',
        },
        {
          startsAt: '2025-04-21T00:00:00',
          endsAt: '2025-04-27T00:00:00',
          type: 'Week',
          identifier: '2025W17',
        },
      ],
      children: [
        {
          StartsAt: '2017-06-13T00:00:00',
          EndsAt: '2017-06-27T00:00:00',
          hierarchyType: 'workitem',
          values: {
            '2025W13': {
              displayValue: 10.0,
              value: 10.0,
              heatmapCode: '',
              editable: true,
            },
            '2025W14': {
              displayValue: 11.0,
              value: 11.0,
              heatmapCode: '',
              editable: true,
            },
            '2025W15': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025W16': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025W17': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
          },
          Budget: 60.0,
          TotalBooked: 21.0,
          TotalActualWorkload: 25.0,
          TotalEAC: 46.0,
          NotPlanned: 14.0,
          PositiveUnplannedHours: 14.0,
          NegativeUnplannedHours: 0,
          total: {
            displayValue: 21.0,
            value: 21.0,
          },
          canExpand: true,
          editable: false,
          canAssign: false,
          canDelete: false,
          resourceId: '399188812783157248',
          resourceSourceReferenceId: 62,
          resourceType: 'Employee',
          workItemId: '399194029218070530',
          workItemSourceReferenceId: '52964',
          workItemType: 'Task',
          hasChildWithEndDateOnTodayOrAfter: false,
          rootParentName: 'Lee 1234567890 Jenn Woei 1234567890',
          id: '399194029218070530',
          name: 'FPSA002',
          sourceReferenceId: '52964',
          tenantId: '3',
          parentId: '399194029192904705',
          type: 'Task',
          pathToParent: '/399194029192904705/',
          sortOrder: 2,
          level: 2,
          sortablePath: '/ _TIMJenm019EURE/002',
          isActive: false,
          startAt: '0001-01-01T00:00:00',
          endAt: '0001-01-01T00:00:00',
          status: 'InProgress',
          lastUserSetIsActive: false,
        },
      ],
    },
    links: [
      {
        href: 'https://localhost:7140/plan/partialgroupbyemployee?periodstartsat=2025-03-27&periodendsat=2025-04-26&periodtypes=week&unittypes=hours&reportingtypes=utilization&showprojectno=true&showtaskno=true&requesthavefilters=true&onlyincludeplanned=true',
        rel: 'self',
      },
    ],
  },
  DeterministicHash: -1557968876,
  StatusCode: 200,
};
